<template>
  <div id="review-result-dialog">
    <ipub-model :title="'Reason for Rejecting Review'"
                width="684px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="mar-b-10 ipubw-p1">
        Reason<font class="key-color">*</font> {{reviewRefuse[params.reasonCode]}}
      </div>
      <div v-if="params.reason"
           class="ipub-p2 mar-b-10"
           v-html="params.reason.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')||'--'"></div>
      <div v-if="params.reviewerList&&params.reviewerList.length">
        <div class="ipubw-p1 mar-b-8">Suggest Reviewers</div>
        <div v-for="item in params.reviewerList"
             class="mar-b-4"
             :key="item.id">{{item.firstName}} {{item.lastName}} ({{item.email||'--'}})</div>
      </div>
      <!-- <div>
        <ipub-select class="mar-b-20"
                     :disabled="true"
                     v-model="inputData.reasonCode"
                     placeholder="Reject Reason">
          <ipub-select-option v-for="(value, key) in reviewRefuse"
                              :key="key"
                              :value="key">
            {{ value }}
          </ipub-select-option>
        </ipub-select>
      </div>
      <ipub-textarea :disabled="true"
                     :autoSize="{ cols: '', rows: '5' }"
                     v-model="inputData.reason" /> -->
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reviewerInvite } from '@/api/reviewer'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {}
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      reviewRefuse: 'getReviewRefuse'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.getDetail(this.inputData.id)
      }
    }
  },
  methods: {
    async getDetail (id) {
      this.params = await reviewerInvite.refuse(id)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
